<template>
  <div class="campaign-form">
    <h3>Campaign Details</h3>
    <div class="flex flex-col w-full">
      <div class="w-full">
        <field-input :model="$v.campaign.name" field-name="Title" label-position="top" placeholder="eg: Coles new store opening or Mount View Netball Club Awards Night"/>
      </div>
      <div class="flex flex-row w-full spacer-y-2">
        <div :class="$hasErrorClass($v.campaign.start_date, 'w-1/2')">
          <label for="start_date" class="control-label">
            Start date
          </label>
          <div class="margin-r-2 input-group">
            <flat-pickr
              id="start_date"
              v-model="$v.campaign.start_date.$model"
              :config="defaultDateConfig"
              class="form-control w-full"
              placeholder="DD/MM/YYYY"
              name="Start date"/>
            <span class="input-group-addon" data-clear>
              <i class="fa fa-times"></i>
            </span>
          </div>
          <vuelidate-help :field="$v.campaign.start_date" :label="'Start date'" :custom-messages="{ 'insideDateBounds': 'This campaign has bookings that are outside this date range. Please update those bookings.' }"/>
        </div>
        <div :class="$hasErrorClass($v.campaign.end_date, 'w-1/2')">
          <label for="end_date" class="control-label">
            End date
          </label>
          <div class="input-group">
            <flat-pickr
              id="end_date"
              :key="$v.campaign.start_date.$model"
              v-model="$v.campaign.end_date.$model"
              :config="endDateConfig"
              class="form-control w-full"
              placeholder="DD/MM/YYYY"
              name="End date"/>
            <span class="input-group-addon" data-clear>
              <i class="fa fa-times"></i>
            </span>
          </div>
          <vuelidate-help :field="$v.campaign.end_date" :label="'End date'" :custom-messages="{ 'insideDateBounds': 'This campaign has bookings that are outside this date range. Please update those bookings.' }"/>
        </div>
      </div>
      <div :class="$hasErrorClass($v.campaign.description, 'w-full redactor-editor-wrapper margin-t-2')">
        <label for="campaign_description" class="control-label">
          Campaign description
        </label>
        <redactor
          id="campaign_description"
          v-model="$v.campaign.description.$model"
          name="campaign_description"
          placeholder="Add information related to the broader campaign, what you are trying to achieve, who's involved and the description of the types of deliverables. This information will only be available to those who are involved in the campaign and not those responding to requests"
          :options="redactorOptions"/>
        <div class="help-block pull-right">
          <span v-if="$v.campaign.description.$error && $v.campaign.description.required === false">Campaign description is required</span>
        </div>
      </div>
      <div class="margin-t-4">
        <slot name="action-buttons"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import FieldInput from '../misc/FieldInput'
import Redactor from 'codium-redactor'
import FlatPickr from 'vue-flatpickr-component'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment-timezone'
import VuelidateHelp from '../misc/VuelidateHelp'
import insideDateBounds from '../../../validators/insideDateBounds'
import isAfterDate from '../../../validators/isAfterDate'

export default {
  components: {FieldInput, FlatPickr, Redactor, VuelidateHelp},

  data () {
    return {
      defaultDateConfig: {
        altInput: true,
        altInputClass: 'w-full form-control input',
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        wrap: true,
        disable: []
      },
      redactorOptions: {
        buttons: ['format', 'bold', 'italic', 'lists', 'link'],
        formatting: ['p'],
        formattingAdd: {
          'h4': {
            title: 'Heading',
            api: 'module.block.format',
            args: ['h4']
          },
          'h5': {
            title: 'Subheading',
            api: 'module.block.format',
            args: ['h5']
          }
        }
      }
    }
  },

  watch: {
    'campaign.start_date' (newValue) {
      if (newValue && moment(newValue)) {
        if (this.campaign.end_date && moment(this.campaign.end_date).isBefore(moment(newValue))) {
          this.campaign.end_date = newValue
        }
      }
    }
  },

  computed: {
    endDateConfig () {
      return {
        ...this.defaultDateConfig,
        defaultDate: this.campaign.end_date && this.campaign.start_date && moment(this.campaign.end_date).isBefore(moment(this.campaign.start_date)) ? this.campaign.start_date : null,
        disable: [
          (date) => {
            if (this.campaign.start_date) {
              return moment(date).isBefore(moment(this.campaign.start_date))
            }
            return false
          }
        ]
      }
    }
  },

  props: {
    campaign: {
      required: true,
      type: Object
    }
  },

  validations () {
    return {
      campaign: {
        name: { required },
        start_date: {
          insideDateBounds: insideDateBounds(null, this.campaign.least_booking_date)
        },
        end_date: {
          insideDateBounds: insideDateBounds(this.campaign.greatest_booking_date, null),
          isAfterDate: isAfterDate(this.campaign.start_date)
        },
        description: {}
      }
    }
  }
}
</script>

<style lang="scss">
.has-error {
  .redactor-box {
    border: 2px #a94442 solid !important;
  }
}
.campaign-form {
  background-color: white;
  padding: 20px;
  .redactor-editor-wrapper {
    .redactor-editor {
      min-height: 150px !important;
    }
    .redactor-box {
      border: 2px black solid;
    }
  }
  h3 {
    margin-top: 10px;
    font-size: 15px;
    letter-spacing: 2px;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 30px;

    &:after {
      content: '';
      display: block;
      height: 2px;
      background: #000;
      width: 15%;
      margin-top: 20px;
    }
  }
}
</style>
